module.exports = __webpack_public_path__ + "static/media/me.3a7d07f5.png";